import React, { Component } from 'react';
import Select from 'react-select'

// import Custom Componenets
import Breadcrumb from '../common/breadcrumb.component';
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import Dropzone from 'react-dropzone';

// koneksi
import { PostMain, GetMain, DeleteMain } from '../../function/Koneksi';

const formInput = {
	uuid: '',
	uuid_invoice: '',
	jenis: '',
	nominal: '',
	keterangan: '',
	file: '',
	link_gambar: '',
	nomor_hp: '',
	pesan: '',
  };

class DetailInvoicePembelian extends Component {

	constructor(props) {
		super(props);
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				share: false,
			},
			awal: "",
			sebelum: "",
			hal: [],
			setelah: "",
			akhir: "",
			dt: formInput,
			judul: "Tambah File Invoice",
			alert: null,
			show: false,
			basicTitle: '',
			basicType: "default",
			pesanAlert: '',

			dataCari: {
				q: '',
			},
			loadingPreview: false,
			masaAktif: '',
			lisensi: null,
			frmJenis: [],
			link_gambar: '',
      		fileInvoice: '',	
      		list_api: [],	
			
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	}

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	}

	hideAlert = () => {
		this.setState({
			alert: null
		});
	}

	// ================== Ambil data dari db untuk table ==================
	fetch = (params = {}) => {
		this.setState({
			loadingPreview: true,
		})
		// let link = "";
		
		// if (params.page) {
		// 	switch (params.page) {
		// 		case ">>":
		// 		  link =
		// 			"?page=" +
		// 			Math.ceil(
		// 			  this.state.pagination.total / this.state.pagination.per_page
		// 			);
		// 		  break;
		// 		case ">":
		// 		  link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
		// 		  break;
		// 		case "<":
		// 		  link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
		// 		  break;
		// 		case "<<":
		// 		  link = "?page=1";
		// 		  break;
		// 		default:
		// 		  link = "?page=" + params.page;
		// 		  break;
		// 	  }
		// }

		let id = this.props.location.state.uuid;
 
		GetMain('main/web/invoice-pembelian/detail/' + id, null, (lihat) => {
			
			if (lihat.results) {
				this.setState({ 
					data: lihat.results.data, 
					pagination: lihat.results,
					loadingPreview: false
				});
				this.pagination(lihat.results);
			}
			else{
				this.setState({ loadingPreview: false, });
			}
		});
	}

	// Pagination
	pagination = (data, tab) => {
		// const data = this.state.pagination;
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
		  let start = 1;
		  let end = 5;
		  let n = 0;
		  let p = 0;
		  if (data.current_page <= 3) {
			start = 1;
			end = 5;
			if (data.last_page > data.current_page) {
			  n = data.current_page + 1;
			}
		  } else {
			p = data.current_page - 1;
			n = data.current_page + 1;
			start = data.current_page - 2;
			end = data.current_page + 2;
		  }
		  if (end >= data.last_page - 2) {
			p = data.current_page - 1;
			if (start >= 5) {
			  start = data.last_page - 4;
			}
			end = data.last_page;
		  }
	
		  for (let i = start; i <= end; i++) {
			let warna = "success";
			if (i === data.current_page) {
			  warna = "danger";
			}
			hal.push(
			  <a
				href={() => false}
				key={i}
				onClick={() => this.fetch({ page: i, tab: tab })}
				className={
				  "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				}
			  >
				{i}
			  </a>
			);
		  }
		  if (p > 0) {
			sebelum = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: p, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{"<"}
			  </a>
			);
		  }
		  if (n > 0) {
			setelah = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: n, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{">"}
			  </a>
			);
		  }
	
		  awal = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: 1, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {"<<"}
			</a>
		  );
		  akhir = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: data.last_page, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {">>"}
			</a>
		  );
		}
	
		
		this.setState({ awal, sebelum, hal, setelah, akhir });
		
	};

	// Cari Data Table
	cariData = e => {
		if (e.key === 'Enter') {
			this.setState({ 
				dataCari:{
					q: e.target.value,
				}, 
			});

			setTimeout(
				function() {
					this.fetch();
				}.bind(this),
				500
			);
		}
	}

	formatCurrency = (value) => {
		return `Rp. ${Number(value).toLocaleString('id-ID')}`;
	};

	currencyFormatter = (cell) => {
		return new Intl.NumberFormat('id-ID', {
		  style: 'currency',
		  currency: 'IDR',
		}).format(cell);
	};

	// Making dynamic function
	handleInputChangeCurrency = (e, fld) => {
		const value = e.target.value.replace(/\D/g, '');
		this.setState({
			dt:{
				...this.state.dt,
				[fld]: value,
			}
		});
	};

	handleInputChange = (e, fld) => {
		this.setState({
			dt:{
				...this.state.dt,
				[fld]: e.target.value
			}
		});
	};

	handleSelectChange = (e, data) => {
		if (e) {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: { value: e.value, label: e.label }
				}
			});
		} else {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: "",
				}
			});
		}
	}
	// Making dynamic function

	// ========================= upload file ======================================

	processGbr = (d) => {
	if (d.length === 1) {
		const tipefile = [
			"jpg", "jpeg", "png", "bmp", "tiff", "webp",
			"pdf", "doc", "docx", "xlsx", "xls"
		];
		this.setState({ loading: true });
		let type = d[0].type.split("/");

		if (tipefile.includes(type[1]) || d[0].name.endsWith(".xlsx") || d[0].name.endsWith(".xls") || d[0].name.endsWith(".doc") || d[0].name.endsWith(".docx")) {
			let bodyFormData = new FormData();
			bodyFormData.append("file", d[0]);
			bodyFormData.append("folder", "File Invoice Desa");
			bodyFormData.append("sub_folder", this.state.list_api.data_desa.nama);
			bodyFormData.append("file_name", this.props.location.state.no_invoice);

			PostMain("main/web/upload-file/store", null, bodyFormData, (data) => {

				this.setState({
				link_gambar: data.data.results,
				fileInvoice: d[0].name,
				loading: false
			});
			},
			{
			"Content-Type": "multipart/form-data",
			}
		);
		} else {
			this.setState({
			loading: false,
			link_gambar: "",
			fileInvoice: "",
			foto_info: (
				<div className="text-danger font-size-10">
				Type file tidak valid
				</div>
			),

			show: true,
			basicType: "danger",
			basicTitle: "Upload File",
			pesanAlert: "Format file tidak sesuai"
			});
		}
	} else {
		this.setState({
			link_gambar: "",
			fileInvoice: "",
			foto_info: (
			<div className="text-danger font-size-10">
				Silahkan masukan satu gambar atau dokumen
			</div>
			),
		});
		}
	};
	
	// ================== simpan data ==================

	simpan = e => {
		e.preventDefault();
		this.setState({ loadingPreview: true })
		
		if(this.state.link_gambar || (this.state.dt.uuid && this.state.dt.file)){
	
		  let add = {
			uuid: this.state.dt.uuid,
			uuid_invoice: this.props.location.state.uuid,
			jenis: this.state.dt.jenis.value,
			nominal: this.state.dt.nominal,
			keterangan: this.state.dt.keterangan,
			file: this.state.link_gambar,
			file_lama : this.state.dt.file,
		  };
	  
		  let psn = "";
		  let resstat = 204;
		  let metode = "create";
		  if (add.uuid === "") {
			psn = "Tambah";
			resstat = 201;
			add.uuid = null;
		  } else {
			psn = "Ubah";
			resstat = 200;
			metode = "update";
		  }
			
		  PostMain("main/web/invoice-pembelian/detail/" + metode, add.uuid, add, res => {
	  
			this.tutupForm();
			this.forceUpdate();
			
			if (res.status === resstat) {
			  this.setState({
				loadingPreview: false,
				show: true,
				basicType: "success",
				basicTitle: "Data File Invoice",
				pesanAlert: "Berhasil " + psn + " Data",
				dt: formInput,
				  status: {
					...this.state.status,
					form: false
				  }
			  });
			} else {
			  this.setState({
				loadingPreview: false,
				show: true,
				basicType: "danger",
				basicTitle: "Data File Invoice",
				pesanAlert: "Gagal " + psn + " Data"
			  });
			}
			this.componentDidMount();
		  });
	
		}
		else{
		  this.setState({
			loadingPreview: false,
			show: true,
			basicType: "danger",
			basicTitle: "Data File Invoice",
			pesanAlert: "Data Tidak Lengkap"
		  });
		}
	};

	ubahData = data => {
		this.setState({
			judul: "Ubah Data File Invoice ",
			loadingPreview: true,
		});

		if (data) {
			this.setState({
				link_gambar: JSON.parse(data.file),
				dt: {
					uuid: data.uuid,
					uuid_invoice: data.uuid_invoice,
					jenis : { value: data.jenis, label: data.jenis },
					nominal : data.nominal,
					keterangan : data.keterangan,
					file : JSON.parse(data.file),
				},
				status: {
					...this.state.status,
					form: true,
				},
				loadingPreview: false,
			})
		}
		else{
			this.setState({
				loadingPreview: false,
			})
		}
		this.forceUpdate();
		this.bukaForm('edit');
	};

	detailData = (data) => {
		this.setState({
			judul: "Detail Data File Invoice ",
			loadingPreview: true,
		});
		if (data) {
			this.setState({
				status:{
					form: true,
					detail: true,
				},
				link_gambar: JSON.parse(data.file),
				dt:{
					uuid:data.uuid,
					uuid_invoice: data.uuid_invoice,
					jenis : { value: data.jenis, label: data.jenis },
					nominal: data.nominal,
					keterangan: data.keterangan,
					file : JSON.parse(data.file),
				},
				loadingPreview: false,
			});
		}
		else{
			this.setState({
				loadingPreview: false,
			})
		}
		this.forceUpdate();
		this.bukaForm('detail');
	}

	ShareFile = (data) => {
		this.setState({
			judul: "Share Data File Invoice ",
			loadingPreview: true,
		});
		if (data) {
			this.setState({
				status:{
					form: true,
					share: true,
				},
				link_gambar: JSON.parse(data.file),
				dt:{
					uuid:data.uuid,
					uuid_invoice: data.uuid_invoice,
					jenis : { value: data.jenis, label: data.jenis },
					nominal: data.nominal,
					keterangan: data.keterangan,
					file : JSON.parse(data.file),
					nomor_hp: '',
					pesan: '',
				},
				loadingPreview: false,
			});
		}
		else{
			this.setState({
				loadingPreview: false,
			})
		}
		this.forceUpdate();
		this.bukaForm('share');
	}

	konfirmHapus = (id) => {
		this.setState({
			alert: (
				<SweetAlert
					showCancel
					confirmBtnText="Hapus"
					confirmBtnBsStyle="danger"
					cancelBtnBsStyle="success"
					type="danger"
					title="Yakin ingin hapus data ?"
					onCancel={this.hideAlert}
					onConfirm={() => this.hapusData(id)}
				>
					Proses ini tidak dapat dibatalkan!
				</SweetAlert>
			)
		});
	}

	handleShareSubmit = () => {
		const { nomor_hp, pesan, file } = this.state.dt;
		
		let status_nomor = false;
		let set_nomor = nomor_hp;
		if (nomor_hp.charAt(0) === "0") {
			set_nomor = "62" + nomor_hp.slice(1);
			status_nomor = true;
		} else if (nomor_hp.slice(0,2) === "62") {
			set_nomor = nomor_hp;
			status_nomor = true;
		}

		if(status_nomor === true){
			const phone = encodeURIComponent(set_nomor);
			const message = encodeURIComponent(`${pesan}\n\nFile Link:\n${file.url}`);
		
			const waLink = `https://api.whatsapp.com/send?phone=${phone}&text=${message}`;
		
			window.open(waLink, '_blank');

			this.setState({ 
				loadingPreview: false,
				show: true, 
				basicType: 'success', 
				basicTitle: 'Berhasil Mengirim', 
				pesanAlert: 'Dokumen barhasil dikirim',
				status: {
					form: false,
					btnForm: false,
					btnAksi: false,
					detail: false,
					share: false,
				},
				dt: formInput,
			});
			this.forceUpdate();
		}
		else{
			this.setState({ 
				loadingPreview: false,
				show: true, 
				basicType: 'warning', 
				basicTitle: 'Gagal Mengirim', 
				pesanAlert: 'Format Nomor Tidak Sesuai',
				status: {
					form: false,
					btnForm: false,
					btnAksi: false,
					detail: false,
					share: false,
				},
				dt: formInput,
			});
			this.forceUpdate();
		}
	};

	hapusData = (id) => {
		this.hideAlert();
		let psn = "Hapus";
		this.setState({
			loadingPreview: true
		})
		DeleteMain('main/web/invoice-pembelian/detail/delete', id, (res) => {
			if (res === 200) {
				this.setState({ 
					loadingPreview: false,
					show: true, 
					basicType: 'success', 
					basicTitle: 'Data File Invoice', 
					pesanAlert: 'Berhasil ' + psn + ' Data' 
				});
			}
			else {
				this.setState({ 
					loadingPreview: false, 
					show: true, 
					basicType: 'danger', 
					basicTitle: 'Data File Invoice', 
					pesanAlert: 'Gagal ' + psn + ' Data' 
				});
			}
			this.componentDidMount();
		})
	}

	bukaForm = (e) => {
		if (e === 'tambah') {
			this.setState({
				dt:formInput,
			})
		}
		this.setState({
			status:{
				...this.state.status,
				form: true
			}
		})
		this.forceUpdate();
	}

	tutupForm = () => {
		this.setState({
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				share: false,
			},
			dt: formInput,
		})
		this.forceUpdate();
	}

	getFilePreview = (data) => {
			
		const fileParse = data.file;
		// const imageUrl = fileParse.thumbnail;
		const fileUrl = fileParse.url;
		const fileName = fileParse.filename;
		const fileExtension = fileName.split('.').pop().toLowerCase();
	
		switch (fileExtension) {
			case 'png':
			case 'jpg':
			case 'jpeg':
		  	case 'pdf':
			case 'xlsx':
			case 'xls':
			case 'doc':
			case 'docx':
			return <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Download File</a>;
		  
			default:
				return (
				<div>
					<p>Format file ini tidak didukung. Silahkan di Download <a href={fileUrl}>Download</a>.</p>
				</div>
			);
		}
	}

	tombolAksi = (cell, row) => {
		return (
			<>
				<Button size="xs" color="primary" className="btn-eye" onClick={() => this.detailData(row)}><i className="fa fa-eye"></i></Button> &nbsp;&nbsp;
				<Button size="xs" color="success" className="btn-icon mr-1" onClick={() => this.ubahData(row)}><i className="fa fa-pencil"></i></Button> &nbsp;
				<Button size="xs" color="danger" className="btn-icon" onClick={() => this.konfirmHapus(row.uuid)}><i className="fa fa-trash"></i></Button> &nbsp;&nbsp;			
				<Button size="xs" color="warning" className="btn-icon mr-1" onClick={() => this.ShareFile(row)}><i className="fa fa-share"></i></Button> &nbsp;&nbsp;
			</>
		)
	}

	componentDidMount() {
		this.fetch({ page: null, where: [] });

		GetMain('master/select-enum-main/invoice_pembelian_detail/jenis', null, (data) => {
			if (data) {	
				let frmJenis = [];
				data.forEach(dt => {
					frmJenis.push({ value: dt, label: dt });
				});
				this.setState({ frmJenis });
			}
		});

		let id_list_api = this.props.location.state.uuid_list_api;

		GetMain('main/web/list-api/find/' + id_list_api, null, (data) => {
			if (data) {
				this.setState({ 
					list_api: data.result, 
					pagination: data.result 
				});
			}
		});
	}
	
	render() {
		var data = this.state.data;
		
		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) =>{          
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index+1);
					let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
					return serial_num; 
				}
			},
			{
				dataField: 'jenis',
				text: 'Jenis Invoice',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'nominal',
				text: 'Nominal',
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: this.currencyFormatter,
			},
			{
				dataField: 'keterangan',
				text: 'Keterangan',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'aksi',
				text: 'Aksi',
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: this.tombolAksi,
			},
		];

		return (
			<div>
				<Breadcrumb title="File Invoice" parent="Admin" />
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-body datatable-react">
									<div className="row">
										<div className="col-sm-6">
											<input
												type="search"
												className="form-control"
												id="cariTable"
												placeholder="Cari Disini..."
												defaultValue={this.state.dataCari.q}
												onKeyPress={this.cariData}
											/>
										</div>
										<div className="col-sm-6 text-right">
											<Button
												size="sm"
												color="default"
												style={{ backgroundColor: '#FFC312' }}
												onClick={this.props.history.goBack}
												className="mr-2"
											>
												<i className="fa fa-arrow-left"></i> Kembali
											</Button>
											<Button 
												size="sm" 
												color="success" 
												className="btn-square" 
												onClick={() => {
													this.setState({ 
														judul: "File Invoice", 
														dt: formInput,
														link_gambar: '',
                            							fileInvoice: '',
													}); 
													this.bukaForm('tambah'); 
												}}>
													Tambah Data
											</Button>
										</div>
									</div>

									<BootstrapTable
										keyField="uuid"
										data={data}
										columns={columns}
									/>
									<div className="pull-right text-white">
										{this.state.awal}
										{this.state.sebelum}
										{this.state.hal.map((dt) => {
											return dt;
										})}
										{this.state.setelah}
										{this.state.akhir}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				{/* Loading preview */}
				<SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>
				
				<Modal styles={{ modal: { width: "70%" } }} open={this.state.status.form} onClose={this.tutupForm} closeOnEsc={false} closeOnOverlayClick={false}>
					<Form className="theme-form" onSubmit={this.state.status.share ? this.handleShareSubmit : this.simpan}>
						<div className="modal-header">
							<h5 className="modal-title">{this.state.judul}</h5>
						</div>
						{this.state.status.share ? (
							<div className="modal-body">
								<FormGroup className="row">
									<Label className="col-sm-3 col-form-label" htmlFor="nomor_hp">Nomor Telepon</Label>
									<Col sm="9">
									<input
										data-testid="nomor_hp"
										id="nomor_hp"
										name="nomor_hp"
										type="number" 
										className="form-control"
										value={this.state.dt.nomor_hp}
										onChange={(e) => this.handleInputChange(e, 'nomor_hp')}
										required
									/>
									<small><font color="red">*Contoh Format Nomor : 628xxxxxxxxx</font></small>
									</Col>
								</FormGroup>
								<FormGroup className="row">
									<Label className="col-sm-3 col-form-label" htmlFor="keterangan">Pesan</Label>
									<Col sm="9">
									<textarea
										className="form-control"
										id="pesan"
										placeholder="Silahkan Masukkan Pesan"
										value={this.state.dt.pesan}
										onChange={(e) => this.handleInputChange(e, 'pesan')}
										required
									/>
									</Col>
								</FormGroup>
							</div>
						) : (
							<div className="modal-body">
								<input className="form-control" id="uuid" type="hidden" placeholder="UUID" defaultValue={this.state.dt.uuid} />
								<FormGroup className="row">
									<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Jenis Invoice</Label>
									<Col sm='9'>
										<Select
											classNamePrefix="select"
											onChange={e => { this.handleSelectChange(e,"jenis")}}
											value={this.state.dt.jenis}
											name="jenis"
											options={this.state.frmJenis}
											placeholder="Pilih Jenis File Invoice"
											isClearable
											isDisabled={this.state.status.detail?true:false}
										/>
									</Col>
								</FormGroup>
								<FormGroup className="row">
									<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Nominal</Label>
									<Col sm='9'>
									<input
										data-testid="nominal"
										id="nominal"
										name="nominal"
										className="form-control"
										value={this.formatCurrency(this.state.dt.nominal)}
										onChange={(e) => this.handleInputChangeCurrency(e, 'nominal')}
										required
										readOnly={this.state.status.detail?true:false}
									/>
									</Col>
								</FormGroup>
								<FormGroup className="row">
									<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Keterangan Invoice</Label>
									<Col sm='9'>
										<textarea 
											className="form-control" 
											id="keterangan" 
											type="text" 
											placeholder="Silahkan Masukkan Keterangan Invoice" 
											defaultValue={this.state.dt.keterangan} 
											onChange={e => this.handleInputChange(e, "keterangan")}
											required
											readOnly={this.state.status.detail?true:false}
										/>
									</Col>
								</FormGroup>
								<FormGroup className="row">
									<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
									>
									File
									</Label>
									{ this.state.status.detail ? (
										<Col sm="9">
										{this.state.dt.file ? (
											<div>
												{this.getFilePreview(this.state.dt)}
											</div>
										) : (
											""
										)}
										</Col>
									) : (
										<Col sm="9">
											<input 
												className="form-control"
												placeholder="File"
												id="file_lama" 
												type="hidden" 
												defaultValue={this.state.dt.file} 
											/>
											<Dropzone
												onDrop={(acceptedFiles) => this.processGbr(acceptedFiles)}
												maxFiles={1}
											>
												{({ getRootProps, getInputProps }) => (
												<section>
													<div
													{...getRootProps()}
													style={{
														minHeight: "100px",
														paddingTop: "40px",
														padding: "5px 5px 5px 5px",
														border: "1px solid #d2d2d2",
													}}
													>
													<input {...getInputProps()} />
													<div
														style={{
														justifyContent: "center",
														alignItems: "center",
														}}
													>
														<p className="text-center">
														{this.state.loading ? (
														<div className="row">
															<div className="col-sm-12" align="center">
															<img
																alt="loading"
																src={require("../../assets/images/tes-loading.gif")}
																style={{
																borderRadius: "10px",
																width: '100px'
																}} />
															</div>
														</div>
														) : this.state.link_gambar ? (
															<img
															src={require("../../assets/images/file-icon.jpg")}
															style={{
															width: '270px'
															}}
															alt=""
														/>
														) : (
															<Label
															className="col-form-label text-center"
															htmlFor="inputEmail3"
															>
															Drag 'n' drop some files here, or click to select files
															</Label>
														)}
														{this.state.fileInvoice ? (
															<div>{this.state.fileInvoice}</div>
														) : (
															""
														)}
														</p>
													</div>
													</div>
												</section>
												)}
											</Dropzone>
										</Col>
									)}
								</FormGroup>
							</div>
						)}
						
						<div className="modal-footer">
							<button type="button" className="btn btn-warning" disabled={this.state.status.btnForm} onClick={this.tutupForm}>Tutup</button>
							{
								this.state.status.share? 
								<button type="submit" className="btn btn-success" onClick={this.handleShareSubmit}>Share</button>
								:
								this.state.status.detail?
								<></>:
								<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm} onClick={this.simpan}>Simpan</button>
							}
						</div>
					</Form>
				</Modal>
			</div>
		)
	}
}


export default DetailInvoicePembelian;
